import React from 'react';
import { compOverrideActionFor } from '../../utils/lionAutoOverrides';

// The listing table's By hand cell for one market listing while a draft is
// open: Not a comp takes it out of the group's comps by hand (the draft's
// excludeCompIds, by its Vivid listing id), Use as comp hands it back to the
// filters (compOverrideActionFor). Disabled for a listing with no Vivid id,
// and while the result on screen is not current (resultStale): the market
// rows are that result's. The button's click stops there, as
// LaOverrideButton's does.
//
// overrides: { excludeCompIds, onToggleComp(vividListingId) };
// listingName: "Sec 112 Row A", so each button's accessible name says which
// listing it acts on.
function LaCompOverrideButton({ overrides, vividListingId, resultStale = false, listingName = '' }) {
  const action = compOverrideActionFor(overrides, { vividListingId, resultStale });
  const handleClick = (e) => {
    e.stopPropagation();
    overrides.onToggleComp(vividListingId);
  };
  return (
    <button
      type="button"
      className="la-link"
      disabled={action.disabled}
      title={action.title}
      aria-label={listingName ? `${action.label} ${listingName}` : action.label}
      onClick={handleClick}
    >
      {action.label}
    </button>
  );
}

export default LaCompOverrideButton;
